import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

/**
 * Show/hide control for a password field.
 *
 * Drop into a TextField's `InputProps.endAdornment` and pair with
 * `type={visible ? "text" : "password"}`. One implementation so every
 * password box in the app looks and reads the same.
 */
export default function PasswordVisibilityToggle({ visible, onToggle }) {
  return (
    <InputAdornment position="end">
      <IconButton
        aria-label={visible ? "Hide password" : "Show password"}
        onClick={onToggle}
        // Toggling must not submit the form it sits inside.
        type="button"
        // Keep the field focused so the user can carry on typing.
        onMouseDown={(e) => e.preventDefault()}
        edge="end"
        size="small"
        sx={{ color: "text.secondary" }}
      >
        {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
      </IconButton>
    </InputAdornment>
  );
}
